module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit","html":"HTML","open":"Open","search":"Search","update":"Update parsed data","url":"URL"}}')
  delete Component.options._Ctor
}
